import { render, staticRenderFns } from "./TemperatureRule.vue?vue&type=template&id=daa53ab8&scoped=true"
import script from "./TemperatureRule.vue?vue&type=script&lang=js"
export * from "./TemperatureRule.vue?vue&type=script&lang=js"
import style0 from "./TemperatureRule.vue?vue&type=style&index=0&id=daa53ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa53ab8",
  null
  
)

export default component.exports